import { useState, useEffect, useRef } from "react";

import { notify } from '../../utils/helpers';

const Dropdown = ({ options, value, onChange, placeholder }) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	const handleItemClick = (selectedValue) => {
		onChange(selectedValue);
		setIsOpen(false);
	};

  	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
  	}, []);

  	return (
		<div className="dropdown" ref={dropdownRef}>
			<div
				className={`form-select border-0 dropdown-input ${!value ? "placeholder" : ""}`}
				style={{ height: '55px', borderRadius: '0px' }}
				tabIndex="0"
				onClick={() => setIsOpen(!isOpen)}
			>
				{value || placeholder}
			</div>
			{isOpen && (
				<ul className="dropdown-menu">
					{options.map((option) => (
						<li key={option.value}>
							<a
								className="dropdown-item"
								href="#"
								onClick={(e) => {
									e.preventDefault();
									handleItemClick(option.value);
								}}
							>
								{option.label}
							</a>
						</li>
					))}
				</ul>
			)}
		</div>
  	);
};

const Request = () => {

	const initFormData = {
		name: "",
		email: "",
		phone: "",
		brand: "",
		group: "",
		model: "",
		engine: "",
		vin: "",
		message: "",
	}
	const [formData, setFormData] = useState(initFormData);

	const [database, setDatabase] = useState(null);
	const [brands, setBrands] = useState([]);
	const [groups, setGroups] = useState([]);
	const [models, setModels] = useState([]);
	const [engines, setEngines] = useState([]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await fetch(process.env.REACT_APP_API_URL, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						type: 'vehicles'
					})
				});
	
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				
				const data = await response.json();
				setDatabase(data);
				setBrands(Object.keys(data));
			} catch (error) {
				console.error('Error loading vehicles:', error);
			}
		};
		fetchData();
	}, []);
	

	useEffect(() => {
		if (database && formData.brand) {
			const brandData = database[formData.brand];
			// Get the groups as an array of options
			const groupOptions = Object.keys(brandData.groups).map((key) => ({
				value: key, 
				label: key, // You can change this label to more readable text if needed
			}));
			setGroups(groupOptions);
			setFormData((prevData) => ({
				...prevData,
				group: "", 
				model: "", 
				engine: "",
			}));
		}
	}, [formData.brand, database]);

	useEffect(() => {
		if (database && formData.brand && formData.group) {
			const brandData = database[formData.brand];
			const groupData = brandData.groups[formData.group];
			const modelOptions = Object.keys(groupData.models).map((key) => ({
				value: key,
				label: key, // Change this to the actual model name if you have it
			}));
			setModels(modelOptions);
			setFormData((prevData) => ({
				...prevData,
				model: "",
				engine: "",
			}));
		}
	}, [formData.group, database]);

	useEffect(() => {
		if (database && formData.brand && formData.group && formData.model) {
			const brandData = database[formData.brand];
			const groupData = brandData.groups[formData.group];
			const modelData = groupData.models[formData.model];
			setEngines(modelData ? modelData.engines : []);
		}
	}, [formData.model, database]);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const [requestLoading, setRequestLoading] = useState(false);
	const [requestHappened, setRequestHappened] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();

		try {
			setRequestLoading(true);

			const res = await fetch(process.env.REACT_APP_API_URL, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ type: "notification", info: formData })
			});

			const data = await res.json();
			if (res.status === 200 && data.type === 'success') {
				setRequestHappened(true);
				setFormData(initFormData);
			}
			notify(data.message, data.type);
		} catch (err) {
			notify('Ceva nu a mers bine...', 'error');
		} finally {
			setRequestLoading(false);
		}
	};

	// Generate dropdown options dynamically
	const brandOptions = brands.map((brand) => ({
		value: brand,
		label: brand.toUpperCase(),
	}));

	const groupOptions = groups.map((group) => ({
		value: group.value,
		label: group.label,
	}));

	const modelOptions = models.map((model) => ({
		value: model.value,
		label: model.label,
	}));

	const engineOptions = engines.map((engine) => ({
		value: engine,
		label: engine,
	}));

	const handleDropdownChange = (name, value) => {
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	return (
		<div className="container-fluid request my-5" id="request">
			<div className="container">
				<div className="row gx-5">

					<div className="col-lg-5 py-5" data-aos="fade-down" data-aos-offset="150" data-aos-delay="700">
						<div className="py-5">
							<h1 className="text-white heading mb-4">Piese Auto de Calitate</h1>
							<p className="text-white mb-0">
							Oferim piese auto originale si aftermarket pentru orice marca si model.
							Beneficiaza de cele mai bune preturi si consultanta specializata.
							Completeaza formularul alaturat pentru a primi o oferta personalizata rapid si usor!
							</p>
						</div>
					</div>

					<div className="col-lg-7">
						<div className="h-100 d-flex flex-column justify-content-center text-center p-5" style={{ backgroundColor: '#d21f1f' }} data-aos="zoom-in" data-aos-offset="150" data-aos-delay="1000">
							<h1 className="text-white heading mb-4">Cere Oferta De Piese</h1>
							
							<form onSubmit={handleSubmit}>
								<div className="row g-3">
									<div className="col-12 col-sm-6">
										<input
											type="text"
											className="form-control border-0 placeholder"
											placeholder="Nume si Prenume"
											style={{ height: '55px', borderRadius: '0px' }}
											name="name"
											value={formData.name}
											onChange={handleChange}
											required
										/>
									</div>

									<div className="col-12 col-sm-6">
										<input
											type="email"
											className="form-control border-0 placeholder"
											placeholder="Adresa Mail"
											style={{ height: '55px', borderRadius: '0px' }}
											name="email"
											value={formData.email}
											onChange={handleChange}
											required
										/>
									</div>

									<div className="col-12 col-sm-6">
										<input
											type="text"
											className="form-control border-0 placeholder"
											placeholder="(+40) 723 531 203"
											style={{ height: '55px', borderRadius: '0px' }}
											name="phone"
											value={formData.phone}
											onChange={handleChange}
										/>
									</div>

									<div className="col-12 col-sm-6">
										<Dropdown
											options={brandOptions}
											value={formData.brand}
											onChange={(value) => handleDropdownChange("brand", value)}
											placeholder="Marca"
										/>
									</div>

									<div className="col-12">
										<Dropdown
											options={groupOptions}
											value={formData.group}
											onChange={(value) => handleDropdownChange("group", value)}
											placeholder="Generatie"
										/>
									</div>

									<div className="col-12">
										<Dropdown
											options={modelOptions}
											value={formData.model}
											onChange={(value) => handleDropdownChange("model", value)}
											placeholder="Model"
										/>
									</div>

									<div className="col-12 col-sm-6">
										<Dropdown
											options={engineOptions}
											value={formData.engine}
											onChange={(value) => handleDropdownChange("engine", value)}
											placeholder="Motor"
										/>
									</div>

									<div className="col-12 col-sm-6">
										<input
											type="text"
											className="form-control border-0 placeholder"
											placeholder="WAUZZZ8T2DA017489"
											style={{ height: '55px', borderRadius: '0px' }}
											name="vin"
											value={formData.vin}
											onChange={handleChange}
										/>
									</div>

									<div className="col-12">
										<textarea
											className="form-control border-0 placeholder"
											placeholder="Spune-ne ce piese auto cauti, iar noi iti oferim cea mai buna oferta rapid si fara efort! Pentru o potrivire perfecta, trimite-ne seria de sasiu, iar noi verificam gratuit compatibilitatea pieselor cu masina ta."
											style={{ height: '135px', borderRadius: '0px' }}
											name="message"
											value={formData.message}
											onChange={handleChange}
											required
										></textarea>
									</div>

									<div className="col-12">
										<button type="submit" className="btn static w-100 py-3" disabled={requestLoading || requestHappened}>
											{requestLoading ? 'Se trimite...' : requestHappened ? 'Te vom contacta in cel mai scurt timp!' : 'Cere Oferta'} 
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>

				</div>
			</div>
		</div>
	);
};

export default Request;
